import { useImpersonation } from "../../context/ImpersonationContext";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, LogOut } from "lucide-react";

export default function ImpersonationBanner() {
  const { impersonation, endImpersonation } = useImpersonation();
  const navigate = useNavigate();

  if (!impersonation) return null;

  const handleExit = async () => {
    await endImpersonation();
    navigate("/super-admin");
  };

  const roleColors = {
    "super-admin": "bg-slate-800",
    admin: "bg-purple-600",
    client: "bg-blue-600",
    operator: "bg-orange-600",
    agent: "bg-teal-600",
    "3pl": "bg-yellow-600",
    customer: "bg-green-600",
    vendor: "bg-violet-600",
  };

  const bannerColor = roleColors[impersonation.role] || "bg-slate-700";

  return (
    <div className={`fixed top-0 left-0 right-0 z-[9999] ${bannerColor} text-white px-4 py-2 flex items-center justify-between shadow-lg`}>
      <div className="flex items-center gap-3">
        <ShieldAlert size={18} className="shrink-0 animate-pulse" />
        <span className="text-sm font-bold">
          SUPER ADMIN TEST MODE
        </span>
        <span className="text-sm opacity-90">
          — Viewing as{" "}
          <span className="font-bold underline">{impersonation.name}</span>
          {" "}({impersonation.role}
          {impersonation.companyId ? ` · ${impersonation.companyId}` : ""})
        </span>
      </div>

      <button
        onClick={handleExit}
        className="flex items-center gap-2 bg-white/20 hover:bg-white/30 text-white text-xs font-bold px-3 py-1.5 rounded-lg transition-colors"
      >
        <LogOut size={14} />
        Exit Testing Mode
      </button>
    </div>
  );
}
